import { AlertCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export const LowConfidenceIcon = () => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger asChild>
        <AlertCircle className="w-4 h-4 text-amber-500 mt-0.5" />
      </TooltipTrigger>
      <TooltipContent>
        <p>Low confidence</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
